<template>
    <entity-reader entity="research" :id="id" :use-sharing="true" api-name="researchRequests">
        <template v-slot:[`reader`]="{ doc }">
            <label-value name="Main Team" :value="doc.teamName" />
            <label-value name="Reference" :value="doc.reference" />
            <label-value name="Research Period" :value="doc.periodName" />
            <label-value name="Deadline" :value="deadlineDate(doc.deadline)" />
            <label-value name="Player Name" :value="doc.realName" />
            <label-value name="Character Name" :value="doc.characterName" />
            <label-value name="Topic" :value="doc.topic" />
            <label-value name="Notes" :value="doc.notes" />
            <label-value-html name="Url" :value="getLink(doc.url)" />
        </template>
    </entity-reader>
</template>
<script>
import EntityReader from '../../components/EntityRead'
import LabelValueRender from '../../components/LabelValueRender'
import LabelValueHtmlRender from '../../components/LabelValueHtmlRender'
export default {
    name: 'ResearchRequestReader',
    components: {
        'entity-reader': EntityReader,
        'label-value': LabelValueRender,
        'label-value-html': LabelValueHtmlRender,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
            validator: value => {
                return !!value
            },
        },
    },
    methods: {
        deadlineDate(deadline) {
            return this.$options.filters.luxonShortDate(deadline)
        },
        getLink(url) {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
        },
    },
}
</script>
